import { render, staticRenderFns } from "./IngredientList.vue?vue&type=template&id=005d4c75"
import script from "./IngredientList.vue?vue&type=script&lang=ts"
export * from "./IngredientList.vue?vue&type=script&lang=ts"
import style0 from "./IngredientList.vue?vue&type=style&index=0&id=005d4c75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports